var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('FdCalendar',{attrs:{"dayNames":['1', '2', '3', '4', '5', '6', '7'],"monthNames":[
      '1️⃣',
      '2️⃣',
      '3️⃣',
      '4️⃣',
      '5️⃣',
      '6️⃣',
      '7️⃣',
      '8️⃣',
      '9️⃣',
      '🔟',
      '1️⃣1️⃣',
      '1️⃣2️⃣'
    ]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }